import { Component, Input } from '@angular/core';

import { TOAST_TYPES } from '../../utils/constants';

@Component({
  selector: 'frodo-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss'],
})
export class CustomSnackbarComponent {
  @Input() message = '';
  @Input() snackType = TOAST_TYPES.Success as string;

  get icon(): string {
    switch (this.snackType) {
      case TOAST_TYPES.Error:
        return 'error_outline';
      case TOAST_TYPES.Warning:
        return 'warning';
      case TOAST_TYPES.Info:
        return 'info';
      default:
        return 'done';
    }
  }
}
